import React from 'react';
import './dialog.sass';

class Dialog extends React.Component {

  closeButton = () => {
    if (this.props.close && this.props.close.callback) {
      let title = this.props.close.title || 'Close';
      return (
        <button onClick={this.props.close.callback}>{title}</button>
      )
    } else {
      return null;
    }
  }

  render() {
    let dialogClassName = 'dialog-fade' + (this.props.open ? ' open' : '');
    return (
      <div className={dialogClassName}>
        <div className="dialog-window">
          <div className="dialog-title">{this.props.title}</div>
          <div className="dialog-body">
            {this.props.children}
            {this.closeButton()}
          </div>
        </div>
      </div>
    );
  }
}

export default Dialog;